module.exports = __webpack_public_path__ + "media/5.4a942bf8.mp4";